"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
var _layout = _interopRequireDefault(require("@/layout"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; } /** When your routing table is too long, you can split it into small modules **/
var gaRouter = {
  path: '/goods_activity',
  component: _layout.default,
  redirect: '/goods_activity/referal_purchase',
  alwaysShow: true,
  name: 'goods_activity',
  meta: {
    title: '菜品活动',
    icon: 'templet'
  },
  children: [{
    path: 'referal_purchase',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/goods_activity/referral_purchase/ReferralPurchaseIndex.vue'));
      });
    },
    name: 'referal_purchase',
    meta: {
      title: '推荐购'
    }
  }, {
    path: 'additive',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/goods_activity/additive/AdditiveIndex.vue'));
      });
    },
    name: 'additive',
    meta: {
      title: '加料推荐'
    }
  }, {
    path: 'best_buys',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/goods_activity/best_buys/BestBuysIndex.vue'));
      });
    },
    name: 'best_buys',
    meta: {
      title: '超值选购'
    }
  }, {
    path: 'goods_promotion',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/goods_activity/goods_promotion/GoodsPromotionIndex.vue'));
      });
    },
    name: 'goods_promotion',
    meta: {
      title: '商品促销'
    }
  }, {
    path: 'group_buy',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/goods_activity/group_buy/GroupBuyIndex.vue'));
      });
    },
    name: 'group_buy',
    meta: {
      title: '拼单优惠'
    }
  }, {
    path: 'promotion',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/goods_activity/promotion/PromotionIndex.vue'));
      });
    },
    name: 'promotion',
    meta: {
      title: '优惠活动'
    }
  }, {
    path: 'booking',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/goods_activity/booking/BookingIndex.vue'));
      });
    },
    name: 'booking',
    meta: {
      title: 'table预订'
    }
  }, {
    path: 'recommend_activity',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/goods_activity/recommend_activity/RecommendActivityIndex.vue'));
      });
    },
    name: 'recommend_activity',
    meta: {
      title: '猜你喜欢'
    }
  }, {
    path: 'qy_group_dinner',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/goods_activity/qy_group_dinner/QyGroupDinnerIndex.vue'));
      });
    },
    name: 'qy_group_dinner',
    meta: {
      title: '企业团餐'
    }
  }]
};
var _default = exports.default = gaRouter;